__turbopack_context__.v({
  "activeWhiteMob": "Tab-module-scss-module__UDRiIG__activeWhiteMob",
  "defaultWhiteMob": "Tab-module-scss-module__UDRiIG__defaultWhiteMob",
  "tab": "Tab-module-scss-module__UDRiIG__tab",
  "tabMob": "Tab-module-scss-module__UDRiIG__tabMob",
  "tabMob__active": "Tab-module-scss-module__UDRiIG__tabMob__active",
  "tabMob__behind": "Tab-module-scss-module__UDRiIG__tabMob__behind",
  "tab__active": "Tab-module-scss-module__UDRiIG__tab__active",
  "tab__behind": "Tab-module-scss-module__UDRiIG__tab__behind",
});
